import { h } from 'preact'
import { signal } from '@preact/signals'
import { Carrousel } from '../carrousel/carrousel.jsx'
import { Publicite } from '../publicite/publicite.jsx'

export const bandeAccueilTvState = signal('')

export const BandeAccueilTv = ({ publicite }) => {
   // Carrousel
   let carrousel = ''
   if (bandeAccueilTvState.value !== '' && bandeAccueilTvState.value['carrousel'] !== undefined) carrousel = bandeAccueilTvState.value['carrousel']

   return (
      <div class="row no-gutters mb-2" data-testid="bande-top-tv">
         <div class="col-12 col-lg-8">{carrousel !== '' ? <Carrousel format={dataStoreHP.device === 'mobile' ? `tv-mobile` : 'tv'} {...carrousel} /> : ''}</div>
         <div class="col-4 d-none d-lg-block">
            <div class="d-flex align-items-center bg-gray2 h-100">
               <Publicite adsId={publicite.rmAdsId} type="rm" />
            </div>
         </div>
      </div>
   )
}
